// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"5511dafa","160":"8d2dd947","165":"3b98b94c","208":"a15b2381","293":"05fddbdd","453":"e901ed7d","516":"3393a468","519":"95e3784c","796":"05328247","917":"b0017bb4","946":"6afb436d"}[chunkId] + ".chunk.js";
};